import { motion } from "framer-motion";
import { UserPlus, Search, Truck, CheckCheck } from "lucide-react";

const steps = [
    {
        title: "Sign Up & Verify",
        description: "Create your account and complete our secure verification process.",
        icon: UserPlus,
    },
    {
        title: "Post or Find Jobs",
        description: "Clients list cargo details; Transporters browse available loads.",
        icon: Search,
    },
    {
        title: "Transport & Track",
        description: "Real-time GPS tracking ensures total visibility during transit.",
        icon: Truck,
    },
    {
        title: "Deliver & Pay",
        description: "Seamless digital payments upon successful delivery execution.",
        icon: CheckCheck,
    },
];

const HowItWorksTimeline = () => {
    return (
        <div className="relative py-12">
            {/* Connecting Line (Vertical) */}
            <div className="absolute left-[50%] top-0 bottom-0 w-1 bg-border -translate-x-1/2 hidden md:block" />

            <div className="space-y-16 relative">
                {steps.map((step, index) => (
                    <motion.div
                        key={index}
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.5 }}
                        transition={{ duration: 0.5, delay: index * 0.1 }}
                        className={`flex flex-col md:flex-row items-center gap-8 ${index % 2 !== 0 ? 'md:flex-row-reverse' : ''}`}
                    >
                        {/* Text Side */}
                        <div className={`flex-1 text-center ${index % 2 !== 0 ? 'md:text-left' : 'md:text-right'}`}>
                            <h3 className="text-2xl font-bold mb-2">{step.title}</h3>
                            <p className="text-muted-foreground text-lg">{step.description}</p>
                        </div>

                        {/* Icon Bubble */}
                        <div className="relative z-10 w-16 h-16 rounded-full bg-background border-4 border-primary flex items-center justify-center shadow-lg group hover:scale-110 transition-transform duration-300">
                            <step.icon className="w-8 h-8 text-primary group-hover:text-accent transition-colors" />
                        </div>

                        {/* Empty Side for Balance */}
                        <div className="flex-1 hidden md:block" />
                    </motion.div>
                ))}
            </div>
        </div>
    );
};

export default HowItWorksTimeline;
